export enum INTERCOM_EVENTS {
  boot = 'boot',
  shutdown = 'shutdown',
  show = 'show',
  update = 'update',
}

export enum METRICS_INTERCOM_NAMES {
  userId = 'user_id',
  userEmail = 'email',
  userHash = 'user_hash',
  name = 'name',
  registered = 'Registered',
  isManagerUser = 'Is Manager User',
  isCreatorUser = 'Is Creator User',
  isCreatorManaged = 'Is Creator Managed',
  isEchoUser = 'Is Echo User',
  agencyId = 'Agency Id',
  agencyName = 'Agency Name',
  agencyRole = 'Agency Role',
  agencyType = 'Agency Type',
  echoWebStatus = 'Echo web-status',
}
